// extracted by mini-css-extract-plugin
export default {"tabGroup":"_5BuNIc06PP50d7neaWm3eO"};